function handleOmnisend(action) {
    if (action === 'open') {
window.omnisend = window.omnisend || [];
window.omnisend.push(['openForm', '6752a2030b7287d7960f47fa']);
    } else if (action === 'close') {
        const floatButton = document.querySelector('.subscribe-float-button');
        if (floatButton) {
            floatButton.classList.add('hidden');
        }
    }
}